import get from 'lodash/get';
import { createSelector } from 'reselect';

import {
  getActiveDesignId,
  getSelectedHotspotUid,
  getStateSliceFor
} from 'redux/Studio';

// This duplication is needed to break  the circular
// dependency between reducer, selectors, and SwapService
// import { reducerKey } from './reducer';
const reducerKey = 'swapProducts';

// =========
// SELECTORS
// =========
export const extractDataFrom = state => getStateSliceFor({ state, reducerKey });

export const getDesignSwappingStatuses = state => extractDataFrom(state).designSwappingStatuses;
export const getDesignToPlaygroundDict = state => extractDataFrom(state).designToPlaygroundDict;
export const getShowSwapNotification = state => extractDataFrom(state).showSwapNotification;
export const getSwapNotificationInfo = state => extractDataFrom(state).swapNotificationInfo;
export const getSwapNotificationDesign = state => extractDataFrom(state).swapNotificationDesign;
export const getShowSwapModal = state => extractDataFrom(state).showSwapModal;
export const getSwapModalInfo = state => extractDataFrom(state).swapModalInfo;
export const getSwapEndResults = state => extractDataFrom(state).swapEndResults;
export const getDesignToCameraDict = state => extractDataFrom(state).designToCameraDict;
export const getSwapModalParentDesignId = state => (
  extractDataFrom(state).swapModalParentDesignId
);

export const getCurrentSwapData = () => (dispatch, getState) => {
  return getSwapData(getState());
};

export const getSwapData = state => get(extractDataFrom(state), 'swapReplacement', null);
export const getRenderInProgress = ({ renderUid, state }) => {
  return extractDataFrom(state).swapRendersInProgress[renderUid] || null;
};

export const getCurrentRenderInProgress = ({ renderUid }) => (_, getState) => {
  return getRenderInProgress({ renderUid, state: getState() });
};

export const getRendersInProgress = state => {
  return extractDataFrom(state).swapRendersInProgress;
};

export const getPlaygroundIdFromDesignId = createSelector(
  state => getDesignToPlaygroundDict(state),
  (designId, designToPlaygroundDict) => {
    if (designId) {
      return designToPlaygroundDict[designId] || null;
    }
    return designId;
  }
);

export const getActiveDesignSwapStatus = createSelector(
  state => getActiveDesignId(state),
  state => getDesignSwappingStatuses(state),
  (designId, statuses) => {
    if (designId) {
      return statuses[designId] || null;
    }
    return designId;
  }
);

export const getProductSwappingStatus = createSelector(
  ({ state }) => getDesignSwappingStatuses(state),
  ({ state }) => getActiveDesignId(state),
  ({ state }) => getSelectedHotspotUid(state),
  ({ productId }) => productId,
  (statuses, designId, hotspotUid, productId) => {
    if (designId && hotspotUid) {
      return get(statuses, `[${designId}][${hotspotUid}]`) === productId;
    }
    return false;
  }
);
